import { atom } from 'recoil'

interface ISnackbar {
    message: string
    opened: boolean
}

const snackbarState = atom<ISnackbar>({
    key: 'snackBarState',
    default: {
        message: '',
        opened: false
    }
})

export default snackbarState
